import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from "@/components/ui/sonner";

const EMAIL_VERIFIED_SESSION_KEY = 'kb_email_verified_toast_shown';

/**
 * Hook to detect email verification success and show a toast
 * Looks for 'jv=1' URL parameter (just verified)
 * Shows toast once per session without URL cleanup to avoid page refreshes
 */
export const useEmailVerifiedToast = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const justVerified = searchParams.get('jv');
    
    // Check if we should show the toast
    if (justVerified === '1') {
      // Check if we've already shown it this session
      const alreadyShown = sessionStorage.getItem(EMAIL_VERIFIED_SESSION_KEY);
      
      if (!alreadyShown) {
        // Add a small delay to ensure Toaster is fully initialized
        setTimeout(() => {
          try {
            // Show the success toast
            toast.success(
              "Email verified",
              { 
                description: "Your email has been successfully verified.",
                duration: 12000, // 12 seconds
                dismissible: true
              }
            );
            
            // Mark as shown for this session
            sessionStorage.setItem(EMAIL_VERIFIED_SESSION_KEY, 'true');
          } catch (error) {
            console.error('Error showing email verification toast:', error);
          }
        }, 100); // 100ms delay to ensure Toaster is ready
      }
      
      // Don't clean up URL parameter - let it stay to avoid page refreshes that crush the toast
    }
  }, [searchParams]);
};
